module.exports = __webpack_public_path__ + "static/media/spaceBackgroundSuperCompressed.3ad1cc28.jpg";